//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import {
  Badge,
  Box,
  Button,
  Collapse,
  Flex,
  HStack,
  // Icon,
  Image,
  Stack,
  Text,
  useDisclosure,
  useRadio,
  useRadioGroup,
} from "@chakra-ui/react";
import Icon from "../../../components/ui-elements/Icon";
import React, { useState } from "react";
import { removeClassPrefix } from "../../../utils/functions";

export const generateOptionDetails = (teacherSplit, as_jsx = true) => {
  let { names, subjectGroup } = teacherSplit;
  let formattedSubjects = subjectGroup.map((subject) =>
    removeClassPrefix(subject)
  );
  let uniqueSubjects = [...new Set(formattedSubjects)];

  let subjects = uniqueSubjects.map((subject, subjectIndex) => {
    return as_jsx ? (
      <span key={subjectIndex}>
        {subject}
        {subjectIndex + 1 < uniqueSubjects.length - 1 && ", "}
        {subjectIndex + 1 === uniqueSubjects.length - 1 && " and "}
      </span>
    ) : (
      `${subject}${subjectIndex + 1 < uniqueSubjects.length - 1 && ", "}
      ${subjectIndex + 1 === uniqueSubjects.length - 1 && " and "}`
    );
  });

  let students = names.map((name, nameIndex) => {
    return as_jsx ? (
      <span key={nameIndex}>
        {name}
        {nameIndex + 1 < names.length - 1 && ", "}
        {nameIndex + 1 === names.length - 1 && " and "}
      </span>
    ) : (
      `${name}${nameIndex + 1 < names.length - 1 && ", "}
    ${nameIndex + 1 === names.length - 1 && " and "}`
    );
  });
  return { students, subjects };
};

export const indexToTeacher = (index, teacherOption) => {
  const oneTutor = teacherOption === "One teacher";
  const indexMapping = {
    1: oneTutor ? "One" : "First",
    2: "Second",
    3: "Third",
    4: "Fourth",
    5: "Fifth",
    6: "Sixth",
    7: "Seventh",
    8: "Eighth",
    9: "Nineth",
  };

  return indexMapping[index + 1];
};
export function renderOption(
  teacherSplitOptions: any,
  as_jsx = false,
  newLayout = false
) {
  const transformedInput = transformInput(teacherSplitOptions);
  const options = transformedInput.map((option: { [key: string]: any }) => {
    let teacherOption = Object.keys(option)[0];
    let numberOfTeachers = Object.values(option)[0].length;
    let selectedTeacherSplit = teacherSplitOptions[teacherOption] || [];
    let formattedTeacherOption =
      teacherOption !== "One teacher"
        ? `${numberOfTeachers} ${teacherOption}`
        : teacherOption;

    const result = selectedTeacherSplit.map((teacherSplit, index) => {
      let { students, subjects } = generateOptionDetails(teacherSplit, as_jsx);
      let vv = indexToTeacher(index, teacherOption);
      const rr = as_jsx ? (
        <Text key={index} fontSize="sm" opacity={"0.8"}>
          <b>{vv} teacher </b> - takes {students} in {subjects}
        </Text>
      ) : (
        `${vv} teacher </b> - takes ${students} in ${subjects}`
      );
      return as_jsx ? <Text key={index}>{rr}</Text> : rr;
    });
    return {
      // description: option.description,
      option: teacherOption,
      numberOfTeachers,
      // title: formattedTeacherOption,
      // desc: result,
      jsx: (isOpen: boolean, onToggle: any) => {
        return (
          <>
            <Stack
              spacing={[3, 4]}
              fontSize="sm"
              isInline
              mt="1.5rem"
              mb="1.5rem"
            >
              <Flex
                width="100%"
                justifyContent="space-between"
                direction={["column", "row"]}
              >
                <Stack mr={[0, 3]} mb={[3, 0]}>
                  <Stack
                    spacing={[0, 0, 3]}
                    isInline
                    flexDirection={["column", "column", "row"]}
                    align={["flex-start", "flex-start", "center"]}
                    mb={2}
                  >
                    <Text fontWeight="semibold" fontSize="md">
                      {formattedTeacherOption}
                    </Text>
                    {teacherOption === "Specialized teachers" && (
                      <Badge
                        px={2}
                        mt={[3, 3, 0]}
                        rounded="fbRadius"
                        variant="subtle"
                        colorScheme="orange"
                        fontSize={"xs"}
                      >
                        Best Results
                      </Badge>
                    )}
                  </Stack>
                  <Text opacity="0.8">{option.description}</Text>

                  <Box
                    pt={[1, 3]}
                    display={
                      newLayout ? { base: "none", lg: "block" } : "block"
                    }
                  >
                    <Button
                      variant="link"
                      alignSelf="flex-start"
                      size="sm"
                      fontWeight="medium"
                      onClick={onToggle}
                      colorScheme="blue"
                    >
                      {isOpen ? "Hide breakdown" : "Show breakdown"}
                    </Button>
                  </Box>
                </Stack>
              </Flex>
            </Stack>

            <Collapse in={isOpen}>
              <Stack pb="3" spacing={4}>
                <Stack spacing={3}>{result}</Stack>
                {numberOfTeachers > 1 &&
                  teacherOption === "Separate teachers" && (
                    <HStack
                      alignSelf="flex-start"
                      py={2}
                      px={2}
                      rounded="md"
                      bg="neutral.300"
                    >
                      <Icon name="fast" color="gold.500" />
                      <Text fontSize="sm" lineHeight="short">
                        Selecting this will cost around {numberOfTeachers}x the
                        price of one tutor
                      </Text>
                    </HStack>
                  )}
              </Stack>
            </Collapse>
          </>
        );
      },
    };
  });
  return options;
}

const CustomRadio = ({
  value,
  teacherOption,
  isRecommended,
  description,
  image,
  numberOfTeachers,
  dataInput,
  radio,
  ...rest
}: any) => {
  const { isOpen, onToggle } = useDisclosure();
  let selectedTeacherSplit = dataInput[teacherOption];
  let isOneTeacher = dataInput.length === 1;

  let formattedTeacherOption =
    teacherOption !== "One teacher"
      ? `${numberOfTeachers} ${teacherOption}`
      : teacherOption;

  const { getInputProps, getCheckboxProps } = useRadio(radio);

  const input: any = getInputProps();
  const checkbox = getCheckboxProps();
  const { checked: isChecked } = input;

  return (
    <Box
      as="label"
      {...checkbox}
      px={[4, 5]}
      py={4}
      cursor="pointer"
      borderColor={"gray.200"}
      borderWidth="2xs"
      _checked={{
        borderColor: "blue.500",
        boxShadow: "outline",
      }}
      rounded="fbRadius"
      flex="1 1 auto"
      _focus={{
        boxShadow: "outline",
      }}
      _hover={{ borderColor: isChecked ? "blue.500" : "gray.300" }}
      {...rest}
    >
      <input {...input} />
      <Stack spacing={[3, 4]} isInline>
        <Icon
          name="check-circle"
          color={isChecked ? "blue.500" : "gray.200"}
          size={6}
        />
        <Flex
          width="100%"
          justifyContent="space-between"
          direction={["column", "row"]}
        >
          <Stack mr={[0, 3]} mb={[3, 0]}>
            <Stack
              spacing={3}
              isInline
              flexDirection={["column", "column", "row"]}
              align={["flex-start", "flex-start", "center"]}
            >
              <Text fontWeight="semibold" fontSize="md">
                {formattedTeacherOption}
              </Text>
              {teacherOption === "Specialized teachers" && (
                <Badge
                  px={2}
                  mt={[3, 3, 0]}
                  rounded="fbRadius"
                  variant="subtle"
                  colorScheme="orange"
                >
                  Best Results
                </Badge>
              )}
            </Stack>
            <Text opacity="0.8">{description}</Text>

            <Box pt={[2, 3]}>
              <Button
                variant="link"
                alignSelf="flex-start"
                size="sm"
                fontWeight="medium"
                onClick={onToggle}
                colorScheme="blue"
              >
                {isOpen ? "Hide breakdown" : "Show breakdown"}
              </Button>
            </Box>
          </Stack>
          <Image
            display={[isOpen ? "none" : "block", "block"]}
            height={["10rem", 32]}
            width={[48, 32]}
            objectFit="cover"
            src={image}
          />
        </Flex>
      </Stack>

      <Collapse in={isOpen}>
        <Stack py={2} spacing={4} ml={[0, 10]}>
          <Stack spacing={4}>
            {selectedTeacherSplit.map((teacherSplit, index) => {
              let { students, subjects } = generateOptionDetails(teacherSplit);
              return (
                <Text key={index}>
                  <b>{indexToTeacher(index, teacherOption)} teacher </b> - takes{" "}
                  {students} in {subjects}
                </Text>
              );
            })}
          </Stack>

          {numberOfTeachers > 1 && teacherOption === "Separate teachers" && (
            <HStack
              alignSelf="flex-start"
              py={2}
              px={2}
              rounded="md"
              bg="neutral.300"
            >
              <Icon name="fast" color="gold.500" />
              <Text fontSize="sm" lineHeight="short">
                Selecting this will cost around {numberOfTeachers}x the price of
                one tutor
              </Text>
            </HStack>
          )}
        </Stack>
      </Collapse>
    </Box>
  );
};

let descriptions = {
  "One teacher": {
    description: "You get 1 teacher to take all selected subjects",
    image: "https://ik.imagekit.io/gbudoh/App_Photos/3_itWRBn1urZ.png",
  },
  "Separate teachers": {
    description: "Each child gets a separate tutor to teach all subjects.",
    image: "https://ik.imagekit.io/gbudoh/App_Photos/1_jvhrmnWDg-s.png",
  },
  "Specialized teachers": {
    description: "Each teacher takes the subjects in which they specialize",
    image: "https://ik.imagekit.io/gbudoh/App_Photos/2_0r5ypN7je.png",
  },
};
/**
 *Transforms the object teacherSplitInput, into an array of objects
 * @param {*} teacherSplitInput - Object of teacher split input
 */
export function transformInput(teacherSplitInput) {
  let result = [];
  Object.entries(teacherSplitInput).forEach(([key, value]) => {
    let newTeacherOptions = {};
    newTeacherOptions[key] = value; //Changes the object into an array of object
    newTeacherOptions["value"] = key; //adds value to array
    newTeacherOptions = { ...newTeacherOptions, ...descriptions[key] };
    result.push(newTeacherOptions);
  });
  return result;
}

const TeacherOptions = ({
  dataInput,
  value: valueProp,
  label,
  onChange,
  spacing = "20px",
  onChangeCallback,
  ...rest
}: any) => {
  let transformedInput = transformInput(dataInput);
  const initialValue =
    transformedInput.length > 0 ? transformedInput[0].value : undefined; //setting the value to the first one on the list}
  const [value, setValue] = useState(valueProp || initialValue);

  const { getRootProps, getRadioProps } = useRadioGroup({
    name: "teacherOptions",
    defaultValue: valueProp || initialValue,
    onChange: (value) => {
      setValue(value);
      onChange(value);
      if (onChangeCallback) {
        onChangeCallback();
      }
    },
  });
  const group = getRootProps();
  return (
    <Stack spacing={spacing} {...group} {...rest}>
      {transformedInput.map((option: { [key: string]: any }) => {
        let teacherOption = Object.keys(option)[0];
        let numberOfTeachers = Object.values(option)[0].length;
        const radio = getRadioProps({ value: option.value } as any);
        return (
          <CustomRadio
            key={option.value}
            {...option}
            dataInput={dataInput}
            teacherOption={teacherOption}
            numberOfTeachers={numberOfTeachers}
            radio={radio}
          />
        );
      })}
    </Stack>
  );
};

export default TeacherOptions;
